export default __webpack_public_path__ + "static/media/corey-roth-ux-resume.22ee34d7.pdf";